import { ColorConf } from "@/config/color";
import { usePWA } from "@/contexts/PWAContext";
import { Platform } from "@/utils/enum";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { Button } from "@mui/material";
import { useState } from "react";
import AndroidChormeGuide from "./AndroidChormeGuide";
import IosGuideModal from "./IosGuide";

const InstallPWAButton = () => {
  const { isInstalled, installPWA, platform } = usePWA();
  const [openModal, setOpenModal] = useState(false);

  const GuideModal =
    platform === Platform.Ios ? IosGuideModal : AndroidChormeGuide;

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        type="button"
        disabled={isInstalled}
        startIcon={<SaveAltIcon />}
        onClick={() => setOpenModal(true)}
        sx={{
          height: 40,
          background: `linear-gradient(264deg, ${ColorConf.Accent100} 0%, ${ColorConf.Primary100} 100%)`
        }}
      >
        インストール
      </Button>
      <GuideModal
        openModal={openModal}
        handleClose={() => setOpenModal(false)}
        handleInstall={() => installPWA(setOpenModal)}
      />
    </>
  );
};

export default InstallPWAButton;
